import { render, staticRenderFns } from "./RecipeTimer.vue?vue&type=template&id=5b6ea59c&scoped=true"
import script from "./RecipeTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeTimer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeTimer.vue?vue&type=style&index=0&id=5b6ea59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ea59c",
  null
  
)

export default component.exports